import { Tag, TagScope } from 'dashboard/models/tag';
import { TagsActions, TagsActionType } from 'dashboard/redux/actions/tags';
import { ApiModel } from 'lib/interfaces/api';

export type Tags = Record<TagScope, Tag[]>;

export interface TagsState {
  tags: Tags;
}

export const initialTagsState: TagsState = {
  tags: {
    // Universal tags in case we need access to all tags
    all: [],

    // Scoped tags per model
    [ApiModel.Account]: [],
    [ApiModel.Case]: [],
    [ApiModel.Inquiry]: [],
    [ApiModel.Report]: [],
    [ApiModel.Transaction]: [],
    [ApiModel.Verification]: [],
  },
};

export default (state: TagsState = initialTagsState, action: TagsActions) => {
  switch (action.type) {
    case TagsActionType.SaveTags: {
      switch (action.payload.tagScope) {
        case ApiModel.Account: {
          return {
            ...state,
            tags: {
              ...state.tags,
              account: action.payload.tags,
            },
          };
        }

        case ApiModel.Case: {
          return {
            ...state,
            tags: {
              ...state.tags,
              case: action.payload.tags,
            },
          };
        }

        case ApiModel.Inquiry: {
          return {
            ...state,
            tags: {
              ...state.tags,
              inquiry: action.payload.tags,
            },
          };
        }

        case ApiModel.Report: {
          return {
            ...state,
            tags: {
              ...state.tags,
              report: action.payload.tags,
            },
          };
        }

        case ApiModel.Verification: {
          return {
            ...state,
            tags: {
              ...state.tags,
              verification: action.payload.tags,
            },
          };
        }

        case ApiModel.Transaction: {
          return {
            ...state,
            tags: {
              ...state.tags,
              transaction: action.payload.tags,
            },
          };
        }

        default: {
          return {
            ...state,
            tags: {
              ...state.tags,
              all: action.payload.tags,
            },
          };
        }
      }
    }

    default: {
      return state;
    }
  }
};
